<!-- 异常持续/关闭时间Column -->
<template>
    <div>
        <span class='color-red'>
            {{ $t('integration.continued') }}
        </span>
        <span>/</span>
        <span style="color: #10BA10;">
            {{ $t('public.close') }}
        </span>
        <span>{{ $t('integration.time') }}</span>
    </div>
</template>

<script>

export default {
    data() {
        return {

        }
    },
}
</script>